import { createContext, useContext, useEffect, useId } from "react";

export interface CambioPendiente {
  seccion: string;
  /** Nombre del cliente al que pertenece el formulario; `null` = el cliente en pantalla cuando se pregunte. */
  cliente: string | null;
}

export interface Registro {
  pendientes: CambioPendiente[];
  registrar: (id: string, cambio: CambioPendiente | null) => void;
}

export const ContextoDeCambios = createContext<Registro | null>(null);

export function useCambiosPendientes(): CambioPendiente[] {
  return useContext(ContextoDeCambios)?.pendientes ?? [];
}

/**
 * Un formulario avisa al marco de que tiene cambios sin guardar mientras `sucio` sea verdadero.
 * El marco bloquea el cambio de cliente y de ruta (`UnsavedChangesGuard`) y el cierre de la pestaña.
 * Fuera del marco (pruebas de una pantalla suelta) no hace nada. Con `cliente` a `null` el aviso nombra al cliente
 * en pantalla, que mientras la guardia pregunta sigue siendo el del formulario (la navegación está bloqueada).
 */
export function useCambiosSinGuardar(seccion: string, cliente: string | null, sucio: boolean): void {
  const id = useId();
  const registrar = useContext(ContextoDeCambios)?.registrar;
  useEffect(() => {
    if (!registrar || !sucio) return;
    registrar(id, { seccion, cliente });
    return () => registrar(id, null);
  }, [registrar, id, seccion, cliente, sucio]);
}
